import { EXPLORE_ROUTES } from "./exploreRoutes";
import React from "react";
import { useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import "../dashboard/Dashboard.css";
import "./HomeDashboard.css";
import MyWalletSidebar from "./MyWalletSidebar";
import LogoIcon from "../assets/images/SliderLogo.png";
import starIcon from "../assets/images/bookmark.png";
import { useStates } from "../hooks/useStates";
import { useAddStateFavourite } from "../hooks/useAddStateFavourite";

function buildStateGroups(states = []) {
  return {
    myStates: states.filter((state) => Number(state?.is_user_state) === 1),
    subscribedStates: states.filter((state) => Number(state?.is_subscribed) === 1),
    favoriteStates: states.filter((state) => Number(state?.is_favourite) === 1),
    otherStates: states.filter(
      (state) =>
        Number(state?.is_user_state) !== 1 &&
        Number(state?.is_subscribed) !== 1 &&
        Number(state?.is_favourite) !== 1
    ),
  };
}

const StateCard = ({
  item,
  onOpen,
  showFavoriteAction = false,
  onFavoriteAction,
  isFavoritePending = false,
  favoriteActionLabel = "",
}) => {
  return (
    <article
      className={`state-card${Number(item?.is_disabled) === 1 ? " choose-state__card--disabled" : ""}${Number(item?.is_disabled) !== 1 ? " subject-info-card--clickable" : ""}`}
      onClick={() => {
        if (Number(item?.is_disabled) === 1) {
          return;
        }

        onOpen?.(item);
      }}
      onKeyDown={(event) => {
        if (Number(item?.is_disabled) === 1) {
          return;
        }

        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen?.(item);
        }
      }}
      role={Number(item?.is_disabled) === 1 ? undefined : "button"}
      tabIndex={Number(item?.is_disabled) === 1 ? undefined : 0}
    >
      <img src={item.state_image} className="state-bg" alt={item.state_name} />

      <div className="state-badge">
        <img src={LogoIcon} alt="" />
      </div>

      {Number(item.is_favourite) === 1 && !showFavoriteAction ? (
        <div className="state-star">
          <img src={starIcon} alt="Favorite state" />
        </div>
      ) : null}

      {showFavoriteAction ? (
        <button
          type="button"
          className="state-star state-star--action"
          onClick={(event) => {
            event.stopPropagation();
            onFavoriteAction?.(item);
          }}
          disabled={isFavoritePending || Number(item?.is_disabled) === 1}
          aria-label={favoriteActionLabel}
        >
          <img src={starIcon} alt="" />
        </button>
      ) : null}

      {Number(item.is_user_state) === 1 || Number(item.is_subscribed) === 1 ? (
        <div className="state-tick">
          <i className="fa-solid fa-check" aria-hidden="true" />
        </div>
      ) : null}

      <div className="state-content">
        <h5>{item.state_name}</h5>
        {item.capital_name ? <p>({item.capital_name})</p> : null}
      </div>

      {Number(item.is_disabled) === 1 ? (
        <div className="choose-state__disabled-tag">Disabled</div>
      ) : null}
    </article>
  );
};

const StateSection = ({
  title,
  items = [],
  gridClassName = "favorite-grid",
  emptyMessage,
  onOpenState,
  showFavoriteAction = false,
  onFavoriteAction,
  favoritePendingStateId = null,
  favoriteActionLabel = "",
}) => {
  return (
    
    <section>
      <div className="quick-action__header Grayborder pb-12">
        <h2 className="quick-action__title">{title}</h2>
      </div>

      {items.length ? (
        <div className={gridClassName}>
          {items.map((item) => (
            <StateCard
              key={item.state_id}
              item={item}
              onOpen={onOpenState}
              showFavoriteAction={showFavoriteAction}
              onFavoriteAction={onFavoriteAction}
              isFavoritePending={Number(favoritePendingStateId) === Number(item.state_id)}
              favoriteActionLabel={favoriteActionLabel ? favoriteActionLabel(item) : ""}
            />
          ))}
        </div>
      ) : (
        <p className="choose-state__status">{emptyMessage}</p>
      )}
    </section>
  );
};

const States = () => {
  const navigate = useNavigate();
  const {
    data: statesData,
    isLoading,
    isError,
    error,
  } = useStates();
  const addStateFavouriteMutation = useAddStateFavourite();

  const loadError = isError
    ? error?.response?.data?.message || error?.message || "Unable to load states."
    : "";

  const groupedStates = buildStateGroups(statesData?.states);

  const handleFavoriteStatusChange = (state, status) => {
    if (!state?.state_id || addStateFavouriteMutation.isPending) {
      return;
    }

    addStateFavouriteMutation.mutate({
      state_id: Number(state.state_id),
      status,
    });
  };

  const handleOpenStateCategories = (state) => {
    if (!state?.state_id) {
      return;
    }

    navigate(EXPLORE_ROUTES.categories, {
      state: {
        state_id: Number(state.state_id),
        selectedState: {
          state_id: Number(state.state_id),
          state_name: state.state_name || "",
          capital_name: state.capital_name || "",
        },
      },
    });
  };

  return (
     <>
      {/* Page Height Setup */}

      <style>
        {`
      .mystates-grid {
        grid-template-columns: repeat(1, 1fr);
       }
      .states-grid {
        grid-template-columns: repeat(1, 1fr);
      }
     .favorite-grid {
       grid-template-columns: repeat(4, 1fr);
      }
       .innerContent .myexams-block .favoritee-grid .state-card {
         height: 250px !important; 
        }
        @media (min-width: 1200px) and (max-width: 1400px){
        .favorite-grid {
       grid-template-columns: repeat(3, 1fr);
        }
        }
         @media (max-width: 991px){
        .favorite-grid {
           grid-template-columns: repeat(3, 1fr);
        }
        }
       @media  (max-width: 576px){
        .favorite-grid {
           grid-template-columns: repeat(2, 1fr);
        }
       .innerContent .myexams-block .favoritee-grid .state-card {
         height: 200px !important;
        }
        }
        @media (max-width:400px){
        .favorite-grid {
          grid-template-columns: repeat(1, 1fr);
        }
        .innerContent .myexams-block .favoritee-grid .state-card {
         height: 160px !important;
        }
        }
        `}
      </style>
    <HomeDashboardLayout showHeader={false}>
      <div className="innerContent innerDashboard ">
        <div className="myexams-block">
          {isLoading ? <p className="choose-state__status">Loading states...</p> : null}
          {!isLoading && loadError ? <p className="choose-state__status choose-state__status--error">{loadError}</p> : null}

          {!isLoading && !loadError ? (
            <>
              <div className="mystates-grid dashboard-states">
                <StateSection
                  title="My States"
                  items={groupedStates.myStates}
                  gridClassName="favoritee-grid"
                  emptyMessage="No states selected yet."
                  onOpenState={handleOpenStateCategories}
                  showFavoriteAction
                  onFavoriteAction={(state) =>
                    handleFavoriteStatusChange(
                      state,
                      Number(state?.is_favourite) === 1 ? 0 : 1
                    )
                  }
                  favoritePendingStateId={addStateFavouriteMutation.variables?.state_id}
                  favoriteActionLabel={(item) =>
                    Number(item?.is_favourite) === 1
                      ? `Remove ${item.state_name} from favorite states`
                      : `Add ${item.state_name} to favorite states`
                  }
                />

                <StateSection
                  title="Subscribed States"
                  items={groupedStates.subscribedStates}
                  emptyMessage="No subscribed states available."
                  onOpenState={handleOpenStateCategories}
                  showFavoriteAction
                  onFavoriteAction={(state) =>
                    handleFavoriteStatusChange(
                      state,
                      Number(state?.is_favourite) === 1 ? 0 : 1
                    )
                  }
                  favoritePendingStateId={addStateFavouriteMutation.variables?.state_id}
                  favoriteActionLabel={(item) =>
                    Number(item?.is_favourite) === 1
                      ? `Remove ${item.state_name} from favorite states`
                      : `Add ${item.state_name} to favorite states`
                  }
                />
              </div>

              <div className="states-grid dashboard-states mt-15">
                <StateSection
                  title="Favorite States"
                  items={groupedStates.favoriteStates}
                  emptyMessage="No favorite states available."
                  onOpenState={handleOpenStateCategories}
                  showFavoriteAction
                  onFavoriteAction={(state) => handleFavoriteStatusChange(state, 0)}
                  favoritePendingStateId={addStateFavouriteMutation.variables?.state_id}
                  favoriteActionLabel={(item) => `Remove ${item.state_name} from favorite states`}
                />

                <StateSection
                  title="Other States"
                  items={groupedStates.otherStates}
                  emptyMessage="No other states available."
                  onOpenState={handleOpenStateCategories}
                  showFavoriteAction
                  onFavoriteAction={(state) => handleFavoriteStatusChange(state, 1)}
                  favoritePendingStateId={addStateFavouriteMutation.variables?.state_id}
                  favoriteActionLabel={(item) => `Add ${item.state_name} to favorite states`}
                />
              </div>
            </>
          ) : null}
        </div>
      </div>

      <MyWalletSidebar />
    </HomeDashboardLayout>
    </>
  );
};

export default States;
